import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, PiggyBank, TrendingDown } from "lucide-react";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="eyebrow">Nos services</div>
        <h1 className="font-display uppercase text-white text-5xl md:text-7xl mt-4 leading-[0.9] tracking-tight max-w-4xl">
          Rénovation<br/><span className="text-[#7DD923]">énergétique</span> complète
        </h1>
        <p className="text-white/70 mt-6 max-w-2xl text-lg">
          Chauffage, climatisation, isolation, aides : nous prenons en charge l'ensemble de votre projet.
        </p>
      </div>

      <div className="mt-20 space-y-24">
        {SERVICES.map((s, i) => (
          <section
            key={s.slug}
            id={s.slug}
            data-testid={`service-detail-${s.slug}`}
            className="max-w-7xl mx-auto px-6 md:px-10"
          >
            <div className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:grid-flow-dense" : ""}`}>
              <div className={i % 2 === 1 ? "lg:col-start-2" : ""}>
                <div className="text-xs uppercase tracking-[0.25em] text-[#7DD923] font-bold">{s.tagline}</div>
                <h2 className="font-display uppercase text-white text-4xl md:text-5xl mt-3 tracking-tight leading-tight">{s.title}</h2>
                <ul className="mt-6 space-y-3">
                  {s.benefits.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-white/80">
                      <CheckCircle2 className="w-5 h-5 text-[#7DD923] mt-0.5 flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 flex flex-wrap gap-4">
                  <div className="glass rounded-xl px-4 py-3 flex items-center gap-2">
                    <TrendingDown className="w-4 h-4 text-[#7DD923]" />
                    <span className="text-white/90 text-sm">{s.savings}</span>
                  </div>
                  <div className="glass rounded-xl px-4 py-3 flex items-center gap-2">
                    <PiggyBank className="w-4 h-4 text-[#7DD923]" />
                    <span className="text-white/90 text-sm">{s.aides}</span>
                  </div>
                </div>
                <div className="mt-8 flex flex-wrap gap-3">
                  <Link to="/devis" className="btn-primary" data-testid={`service-cta-devis-${s.slug}`}>Étude gratuite <ArrowRight className="w-4 h-4" /></Link>
                  <Link to="/simulateur" className="btn-secondary">Simuler mes aides</Link>
                </div>
              </div>
              <div className={`relative ${i % 2 === 1 ? "lg:col-start-1" : ""}`}>
                <div className="rounded-3xl overflow-hidden border border-white/5">
                  <img src={s.image} alt={s.title} className="w-full h-[420px] object-cover" />
                </div>
                <div className="absolute -bottom-6 -right-4 glass rounded-2xl p-4 max-w-[220px] hidden md:block">
                  <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">Aides estimées</div>
                  <div className="font-display text-2xl text-white mt-1">{s.aides}</div>
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
